import {
    ContactForm,
    ContactFormData
} from "./ContactForm";
import {
    Dialog,
    DialogContent,
    DialogTitle
} from "@mui/material";
import {
    Dispatch,
    SetStateAction
} from "react";

import { Contact } from "../../models";

type ContactFormDialogProps = {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    onSubmit: (formData: ContactFormData) => void;
} & ({
    contact: Contact;
    type: "edit";
} | {
    type: "add";
});

export const ContactFormDialog = (props: ContactFormDialogProps) => {
    const { isOpen, setIsOpen, onSubmit, type } = props;

    return (
        <Dialog
            disableEnforceFocus
            open={isOpen}
            onClose={() => setIsOpen(false)}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                {type === "edit" && "Edit Contact"}
                {type === "add" && "Add Contact"}
            </DialogTitle>
            <DialogContent>
                <ContactForm
                    existingContact={type === "edit" ? {
                        name: props.contact.name || "",
                        email: props.contact.email || undefined,
                        phoneNumber: props.contact.phoneNumber || undefined
                    } : undefined}
                    onCancel={() => setIsOpen(false)}
                    onSubmit={onSubmit}
                />
            </DialogContent>
        </Dialog>
    );
};